import { render } from "./PaginationCustom.vue?vue&type=template&id=f20fc0c0"
import script from "./PaginationCustom.vue?vue&type=script&lang=js"
export * from "./PaginationCustom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__